import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import "./vendorServices.css";
import axiosInstance from "../../../API/axiosInstance";
import { FaStar, FaTrash, FaRupeeSign, FaMapMarkerAlt, FaEdit } from "react-icons/fa";
import useAuthCheck from "../../../Auth/useAuthCheck";
import { fetchStates } from '../../../API/Resources/fetchStates';
import { fetchCategories } from '../../../API/Resources/fetchCategories';
import { fetchCities } from '../../../API/Resources/fetchCities';
import { toast, ToastContainer, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import images from "../../../Resources/images";
import DynamicBreadcrumbs from '../../dynamic_breadcumb/dynamic_breadcrumb';
import { Link } from 'react-router-dom';


const VendorServices = () => {
  const [vendorServices, setVendorServices] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedState, setSelectedState] = useState(null);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [currentUser, setCurrentUser] = useState(null); // Start with null
  const navigate = useNavigate();
  useAuthCheck();

  const notify = (status) => {
    (status === "success") ? (toast.success('Service deleted successfully!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
    })) : (toast.error('Something went wrong.', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
    }))
  };

  useEffect(() => {
    const initializeAppData = async () => {
      const stateList = await fetchStates();
      setStates(stateList);

      const categoryList = await fetchCategories();
      setCategories(categoryList);

      const storedUserString = localStorage.getItem('currentUser');
      if (storedUserString) {
        setCurrentUser(JSON.parse(storedUserString));
      }
    };

    initializeAppData();
  }, []);


  const fetchServicesForUser = async () => {
    if (currentUser && currentUser.id) {
      const token = localStorage.getItem("token");

      if (!token) {
        console.error("Authentication token not found.");
        toast.error("You are not logged in.");
        return;
      }

      try {
        const response = await axiosInstance.get(
          `/service/${currentUser.id}/all`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setVendorServices(response.data);
      } catch (error) {
        console.error("Error fetching vendor services:", error);
        toast.error("Could not fetch your services.");
      }
    }
  };

  useEffect(() => {
    fetchServicesForUser();
  }, [currentUser]);

  const handleDeleteService = (serviceId) => async () => {
    try {
      notify("success");
      setVendorServices(vendorServices.filter((service) => service.id !== serviceId));
    } catch (error) {
      notify("failed");
      console.error("Error deleting service:", error);
    }
  }

  const handleEditService = async (service) => {
    console.log(service);
  }

  const handleChange = async (name, event) => {
    const value = event.target.value;
    if (name === "state") {
      setSelectedState(value);
      const response = await fetchCities(value);
      setCities(response);
      setSelectedCity("");
    }
    if (name === "city") {
      setSelectedCity(value);
    }
    if (name === "category") {
      setSelectedCategory(value);
    }
  };

  const findVendors = async (location, category) => {
    if (!currentUser || !currentUser.id) return;

    try {
      const token = localStorage.getItem("token");

      const response = await axiosInstance.get(`/service/by-vendor/${currentUser.id}/by-location/${location}/by-category/${category}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setVendorServices(response.data);
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const handleClearFilter = () => {
    setSelectedState('');
    setSelectedCity('');
    setSelectedCategory('');
    fetchServicesForUser()
  };

  return (
    <div className='container'>
      <ToastContainer />
      <div className="container-fluid ">
        <h1 className="text-center my-2"><b>Available Services</b></h1>

        {/* vendor filters */}
        <div id="vendor-filter">
          <div class="container text-center">
            <div className="row" style={{ height: "max-content", width: "100%" }}>
              {/* State Dropdown */}
              <div className={selectedState ? 'col-md-4 m-0' : 'col-md-5 m-0'} style={{ height: "max-content" }}>
                <section id="location-select-section">
                  <img src={images.locationLogo} id="location-icon" alt="location icon" />
                  <select
                    className="form-select form-select-lg"
                    aria-label="Large select example"
                    id="location-select"
                    value={selectedState} // Make it a controlled component
                    onChange={(e) => handleChange("state", e)}
                  >
                    <option value="">Select a State</option>
                    {states.map((state) => (
                      <option key={state} value={state}>
                        {state}
                      </option>
                    ))}
                  </select>
                </section>
              </div>

              {/* City Dropdown */}
              {selectedState && (
                <div className={'col-md-4 m-0'} style={{ height: "max-content" }}>
                  <section id="location-select-section">
                    <img src={images.locationLogo} id="location-icon" alt="location icon" />
                    <select
                      className="form-select form-select-lg"
                      aria-label="Large select example"
                      id="location-select"
                      value={selectedCity} // Make it a controlled component
                      onChange={(e) => handleChange("city", e)}
                      disabled={!cities.length}
                    >
                      <option value="">Select a City</option>
                      {cities.map((city, index) => (
                        <option key={index} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                  </section>
                </div>
              )}

              {/* Category Dropdown */}
              <div className={selectedState ? 'col-md-4 m-0' : 'col-md-5 m-0'} style={{ height: "max-content" }}>
                <section id="location-select-section">
                  <img src={images.vendorLogo} id="location-icon" alt="vendor icon" />
                  <select
                    className="form-select form-select-lg"
                    aria-label="Large select example"
                    id="category-select"
                    value={selectedCategory} // Make it a controlled component
                    onChange={(e) => handleChange("category", e)}
                  >
                    <option value="">Select a Category</option>
                    {categories.map((category) => (
                      <option key={category.id} value={category.category_name}>
                        {category.category_name}
                      </option>
                    ))}
                  </select>
                </section>
              </div>

              {/* Button Container */}
              <div className={selectedState ? 'col-md-12 mt-3 d-flex justify-content-center' : 'col-md-2 m-0 d-flex align-items-center'}>
                {/* Find Vendor Button */}
                <button
                  type="button"
                  id="find-vendor-btn"
                  className="btn btn-lg me-2" // Added margin to the right
                  onClick={() => findVendors(selectedCity, selectedCategory)}
                >
                  <section>
                    <span style={{ paddingTop: "2px" }}>Find Vendor </span>
                    <img src={images.rightArrow} style={{ height: "27px", paddingBottom: "2px" }} alt="find vendor" />
                  </section>
                </button>

                {/* NEW: Clear Filter Button - Conditionally Rendered */}
                {(selectedState || selectedCity || selectedCategory) && (
                  <button
                    type="button"
                    id="clear-filter-btn"
                    className="btn btn-lg btn-outline-secondary" // Example styling
                    onClick={handleClearFilter}
                  >
                    Clear
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>


        {vendorServices.length === 0 && (
          <p className="text-center text-muted py-5">No services available.</p>
        )}
        <div className='row g-3' id='card-deck'>
          {vendorServices.map((service, index) => (
            <div key={service.id || index} className='col-12 col-md-6 col-lg-4' id='service-col'>
              <div className="card service-card" onClick={() => navigate(`/service-details/${service.id}`)}>
                {/* ...your card JSX remains unchanged... */}
                <span className="badge text-bg-warning service-badge m-2 px-3 py-2">
                  {service.category}
                </span>
                <div className="service-image position-relative">
                  <img
                    src={service.images && service.images.length > 0 ? service.images[0] : "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png"}
                    alt={service.service_name}
                    className="card-img-top rounded-top"
                  />
                </div>
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title fw-bold">{service.service_name}</h5>
                  <p className="card-text text-muted small" id='description'>{service.description}</p>
                  <p className="price text-dark fw-semibold fs-5">
                    <FaRupeeSign className="text-success" /> {service.min_price} - <FaRupeeSign className="text-success" /> {service.max_price}
                  </p>
                  <div className="d-flex align-items-center text-muted fs-6">
                    <FaStar className="text-warning" />
                    <span className="ms-1">{service.ratings ? service.ratings.toFixed(1) : "N/A"}</span>
                    <span className="ms-2">({service.reviews ? service.reviews.length : 0} reviews)</span>
                  </div>
                  <p className="location text-muted fs-6 d-flex align-items-center">
                    <FaMapMarkerAlt className="me-1 text-danger" /> {service.location}
                  </p>
                  <p className="text-muted small">
                    Created: {new Date(service.created_at).toLocaleDateString()}
                  </p>
                  <div className="mt-auto d-flex justify-content-between gap-2">
                    {/* Edit Button */}
                    <Link
                      to={`/vendor/${currentUser.id}/service/${service.id}/edit`}
                      onClick={(e) => e.stopPropagation()}
                      state={{ service: service }}
                    >
                      <button className="btn btn-primary w-100">
                        <FaEdit className="me-1" /> Edit
                      </button>
                    </Link>
                    {/* Delete Button */}
                    <button
                      className="btn btn-danger w-100"
                      onClick={() => handleDeleteService(service.id)}
                    >
                      <FaTrash className="me-1" /> Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VendorServices;